import { useState } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import closeFill from '@iconify/icons-eva/close-fill';
import expandFill from '@iconify/icons-eva/expand-fill';
import attach2Fill from '@iconify/icons-eva/attach-2-fill';
import collapseFill from '@iconify/icons-eva/collapse-fill';
import minimizeFill from '@iconify/icons-eva/minimize-fill';
import roundAddPhotoAlternate from '@iconify/icons-ic/round-add-photo-alternate';
// material
import { useTheme, styled } from '@material-ui/core/styles';
import {
    Box,
    Input,
    Portal,
    Button,
    Divider,
    Backdrop,
    IconButton,
    Typography,
    useMediaQuery,
    Stack,
    Avatar,
    Badge,
    TextField,
    InputAdornment
} from '@material-ui/core';
import ChatMessageList from '../../components/_dashboard/chat/ChatMessageListZalo';
import EmojiPicker from '../../components/EmojiPicker';
//import ChatMessageInput from '../../components/_dashboard/chat/ChatMessageInput';
import { PATH_DASHBOARD } from '../../routes/paths';
import { useRef } from 'react';
import { useDispatch, useSelector } from '../../redux/store';
import ChatMessageInput from '../../components/_dashboard/zalo/ChatMessageInput';
import { getMoreMesageConversation, sendMessage } from '../../redux/slices/conversationZalo';
import MinimizeIcon from '@mui/icons-material/Minimize';
//
// ----------------------------------------------------------------------
const RootStyle = styled('div')(({ theme }) => ({
    right: 0,
    bottom: 0,
    zIndex: 1999,
    minHeight: 440,
    outline: 'none',
    display: 'flex',
    position: 'fixed',
    overflow: 'hidden',
    flexDirection: 'column',
    margin: theme.spacing(3),
    boxShadow: theme.customShadows.z20,
    borderRadius: theme.shape.borderRadiusMd,
    backgroundColor: theme.palette.background.paper
}));

const InputStyle = styled(Input)(({ theme }) => ({
    padding: theme.spacing(0.5, 3),
    borderBottom: `solid 1px ${theme.palette.divider}`
}));

const SmallAvatar = styled(Avatar)(({ theme }) => ({
    width: 24,
    height: 24,
    border: `1px solid ${theme.palette.background.paper}`,
}));
// ----------------------------------------------------------------------


export default function ChatWindowMiniZalo({ isOpenWindowZalo, onCloseWindowChat, onMinimizeWindowZalo, infoToChat }) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const dispatch = useDispatch();
    const { conversationContent, infoUserSelected, endPage } = useSelector(state => state.conversationZalo);
    console.log(conversationContent)
    const { uid, app_id, oa_id } = infoUserSelected;
    const [fullScreen, setFullScreen] = useState(false);
    const [message, setMessage] = useState('');
    // const conversation = useState({});
    const fileInputRef = useRef(null);
    const [page, setPage] = useState(1);
    const handleChangeMessage = (value) => {
        setMessage(value);
    };

    const handleExitFullScreen = () => {
        setFullScreen(false);
    };

    const handleEnterFullScreen = () => {
        setFullScreen(true);
    };

    const handleClose = (uid) => {
        onCloseWindowChat(uid, "zalo");
        setFullScreen(false);
    };
    const handleMinimize = () => {
        onMinimizeWindowZalo();
        setFullScreen(false);
    };

    const handleAttach = () => {
        fileInputRef.current.click();
    };
    if (!isOpenWindowZalo) {
        return null;
    }
    const handleSendMessage = async (value) => {
        value.oa_id = oa_id;
        value.app_id = app_id;
        dispatch(sendMessage(value));
    };
    const loadMoreMessage = async () => {
        if (!endPage) {
          setPage(page + 1);
          dispatch(getMoreMesageConversation({ app_id, oa_id, uid, page: page + 1 }));
        }
      }
    return (
        <Portal>
            <Backdrop open={fullScreen || isMobile} sx={{ zIndex: 1998 }} />
            <RootStyle
                sx={{
                    ...(fullScreen && {
                        top: 0,
                        left: 0,
                        zIndex: 1999,
                        margin: 'auto',
                        width: {
                            xs: `calc(100% - 24px)`,
                            md: `calc(100% - 80px)`
                        },
                        height: {
                            xs: `calc(100% - 24px)`,
                            md: `calc(100% - 80px)`
                        }
                    }),
                    width: '18%',
                    [theme.breakpoints.only('xl')]: {
                        width: '20%'
                    },
                    [theme.breakpoints.between('lg' ,'xl')]: {
                        width: '24%'
                    },

                    mr: "4%"
                }}
            >
                <Box
                    sx={{
                        pl: 3,
                        pr: 1,
                        height: 60,
                        display: 'flex',
                        alignItems: 'center'
                    }}
                >
                    <Stack direction="row" alignItems="center">
                        <Badge
                            overlap="circular"
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                            badgeContent={
                                <SmallAvatar src={"/static/icons/icons8-zalo.svg"} alt="Channel" />
                            }
                        >
                            <Avatar src={infoToChat.urlImage} sx={{ width: 40, height: 40 }} />
                        </Badge>
                        <Stack>
                            <Typography variant="subtitle2" sx={{ ml: 1 }} noWrap>
                                {infoToChat.name}
                            </Typography>
                            <Typography variant="subtitle2" sx={{ ml: 1 }} noWrap>
                                {infoToChat.name_oa}
                            </Typography>
                        </Stack>
                    </Stack>
                    {/* <Typography variant="h6">New Message</Typography> */}
                    <Box sx={{ flexGrow: 1 }} />
                    <IconButton onClick={fullScreen ? handleExitFullScreen : handleEnterFullScreen}>
                        <Icon icon={fullScreen ? collapseFill : expandFill} width={20} height={20} />
                    </IconButton>
                    <IconButton onClick={handleMinimize}>
                        <MinimizeIcon width={20} height={20} />
                    </IconButton>
                    <IconButton onClick={() => handleClose(uid)}>
                        <Icon icon={closeFill} width={20} height={20} />
                    </IconButton>

                </Box>

                <Divider />

                {/* <InputStyle disableUnderline placeholder="To" />

                <InputStyle disableUnderline placeholder="Subject" /> */}
                <Box sx={{ height: 120, flexGrow: 1, display: 'flex', overflow: 'hidden' }}>
                    <Box sx={{ display: 'flex', flexGrow: 1, flexDirection: 'column' }}>
                        <ChatMessageList pageCurrent={page} endPage={endPage} oa_id={oa_id} uid={uid} conversation={conversationContent} loadMoreMessage={loadMoreMessage}  />
                        <Divider />
                        <ChatMessageInput
                            user_id={uid}
                            onSend={handleSendMessage}
                            disabled={false}
                        />
                    </Box>

                    {/* {mode === 'DETAIL' && <ChatRoom conversation={conversation} participants={[]} />} */}
                </Box>

                {/* <Box sx={{ py: 2, px: 3, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <InputAdornment position="start">
                        <EmojiPicker value={message} setValue={setMessage} />
                    </InputAdornment>
                    <TextField
                        id="standard-textarea"
                        placeholder="Nhập tin nhắn..."
                        multiline
                        variant="standard"
                        fullWidth
                        disableUnderline
                    />
                    <IconButton size="small" sx={{ ml: 1, mr: 1 }}>
                        <Icon icon="mingcute:send-plane-fill" width={24} height={24} />
                    </IconButton>
                    <IconButton size="small" sx={{ ml: 1, mr: 1 }}>
                        <Icon icon={roundAddPhotoAlternate} width={24} height={24} onClick={handleAttach} />
                    </IconButton>
                    <IconButton size="small">
                        <Icon icon={attach2Fill} width={24} height={24} onClick={handleAttach} />
                    </IconButton>
                  
                     <input type="file" ref={fileInputRef} style={{ display: 'none' }} />
                </Box> */}
            </RootStyle>
        </Portal>
    );
}
